export interface SiteConfig {
  name: string
  legalName: string
  url: string
  phone: string
  email: string
  address: string
  locality: string
  region: string
  postalCode: string
  openingHours: string
}

const publicSiteUrl = (
  import.meta.env?.VITE_PUBLIC_SITE_URL
  ?? import.meta.env?.PUBLIC_SITE_URL
  ?? 'https://autoglowdetailing.com.au'
).replace(/\/$/, '')

export const siteConfig: SiteConfig = {
  name: 'Autoglow Detailing',
  legalName: 'Autoglow Detailing',
  url: publicSiteUrl,
  phone: '0493 216 439',
  email: 'bookings@app.autoglowdetailing.com.au',
  address: '5/4 Clarendon Rd, Drysdale VIC 3222',
  locality: 'Drysdale',
  region: 'VIC',
  postalCode: '3222',
  // Display hours disagree with booking_availability_rules and contact-page copy.
  // Do not change until Lyle confirms. Workbench question 4d14a77d remains open.
  openingHours: 'Mon - Fri: 9:00am - 5:30pm',
}
